<section class="balanca-page" [class.em-dialog]="emDialog">
  <header *ngIf="!emDialog">
    <p class="eyebrow"><i class="fe-monitor" aria-hidden="true"></i> Equipamentos · Este computador</p>
    <h1>Balança</h1>
    <p>Prepare a conexão e confira a leitura antes de começar a vender.</p>
  </header>

  <div class="compatibilidade" *ngIf="!balanca.suportada" role="status">
    <i class="fe-info" aria-hidden="true"></i>
    <span>Para conectar a balança, abra o sistema em Chrome ou Edge no computador, usando HTTPS ou localhost.</span>
  </div>

  <div class="balanca-workspace">
    <section class="configuracao" aria-labelledby="titulo-config-balanca">
      <h2 id="titulo-config-balanca">Conexão</h2>
      <p class="subtitulo">Escolha a balança conectada a este computador.</p>
      <label class="campo">Modelo da balança
        <select [ngModel]="config.modelo" (ngModelChange)="mudarModelo($event)"
                [disabled]="balanca.conectada || balanca.ocupada">
          <option value="urano">Urano US 31/2 POP-S</option>
          <option value="elgin">Elgin DP30-T</option>
        </select>
      </label>

      <div class="instrucoes">
        <strong>Na balança</strong>
        <p *ngIf="config.modelo === 'urano'">Pressione F, depois 3. Use P para escolher PROT 3 e confirme com E.</p>
        <p *ngIf="config.modelo === 'elgin'">No menu RS-232, configure 1010: serial ligada, Demanda peso 1, 9600 baud e N81.</p>
        <span>Use o cabo ou adaptador compatível com a saída da sua balança. O conversor USB pode precisar de driver.</span>
      </div>

      <details>
        <summary>Avançado <span>Parâmetros seriais</span></summary>
        <p class="subtitulo">Os valores são preenchidos pelo modelo. Altere apenas para corresponder à configuração da sua balança.</p>
        <div class="parametros">
          <label class="campo">Velocidade
            <select [(ngModel)]="config.baudRate" [disabled]="balanca.conectada || balanca.ocupada">
              <option [ngValue]="2400">2400 baud</option><option [ngValue]="4800">4800 baud</option>
              <option [ngValue]="9600">9600 baud</option><option [ngValue]="19200">19200 baud</option>
            </select>
          </label>
          <label class="campo">Bits de dados
            <select [(ngModel)]="config.dataBits" [disabled]="balanca.conectada || balanca.ocupada">
              <option [ngValue]="7">7</option><option [ngValue]="8">8</option>
            </select>
          </label>
          <label class="campo">Paridade
            <select [(ngModel)]="config.parity" [disabled]="balanca.conectada || balanca.ocupada">
              <option value="none">Nenhuma</option><option value="even">Par</option><option value="odd">Ímpar</option>
            </select>
          </label>
          <label class="campo">Bits de parada
            <select [(ngModel)]="config.stopBits" [disabled]="balanca.conectada || balanca.ocupada">
              <option [ngValue]="1">1</option><option [ngValue]="2">2</option>
            </select>
          </label>
        </div>
        <button class="text-button" type="button" (click)="restaurarPadrao()" [disabled]="balanca.conectada || balanca.ocupada">Restaurar padrão do modelo</button>
      </details>

      <button class="secondary" type="button" (click)="salvar()" [disabled]="balanca.conectada || balanca.ocupada || !alterada">Salvar preferências</button>
      <p class="nota">Preferências apenas neste navegador. Ao recarregar, o sistema tenta reconectar a porta já autorizada. Se houver mais de uma, escolha a porta da balança.</p>
      <p class="aviso" *ngIf="balanca.avisoPreferencias" role="status">{{ balanca.avisoPreferencias }}</p>
      <p class="salvo" *ngIf="mensagem" role="status">{{ mensagem }}</p>
    </section>

    <section class="teste" aria-labelledby="titulo-teste-balanca">
      <h2 id="titulo-teste-balanca">Teste de leitura</h2>
      <p class="subtitulo">Confira o peso sem selecionar produto ou criar pedido.</p>
      <div class="status" [class.sucesso]="balanca.comunicacaoValidada && !balanca.erro && !balanca.avisoLeitura && !balanca.ocupada"
           [class.aviso]="!!balanca.avisoLeitura" [class.falha]="!!balanca.erro" role="status">
        <span class="status-dot" aria-hidden="true"></span>{{ balanca.status }}
      </div>
      <div class="peso" aria-live="polite" aria-atomic="true">
        <span class="peso-label">{{ balanca.ultimaLeitura ? 'Última leitura válida' : 'Peso recebido' }}</span>
        <div class="peso-numero">{{ balanca.ultimaLeitura ? (balanca.ultimaLeitura.pesoKg | number:'1.3-3') : '—' }} <small>kg</small></div>
        <span class="horario" *ngIf="balanca.ultimaLeitura">Recebido às {{ balanca.ultimaLeitura.horario | date:'HH:mm:ss' }}</span>
        <span class="horario" *ngIf="!balanca.ultimaLeitura">Nenhuma leitura nesta conexão</span>
      </div>
      <p class="instrucao-teste">Coloque um item no prato, aguarde estabilizar e compare a leitura com o visor. O teste também aceita a balança zerada.</p>
      <div class="acoes">
        <button class="primary" type="button" *ngIf="!balanca.conectada" (click)="conectar()" [disabled]="balanca.ocupada || !balanca.suportada">
          {{ balanca.ocupada ? 'Conectando…' : alterada ? 'Salvar e conectar' : 'Conectar balança' }}
        </button>
        <button class="primary" type="button" *ngIf="balanca.conectada" (click)="testar()" [disabled]="balanca.ocupada">
          {{ balanca.ocupada ? 'Aguardando peso…' : 'Testar leitura' }}
        </button>
        <button class="text-button" type="button" *ngIf="balanca.conectada" (click)="balanca.desconectar()" [disabled]="balanca.ocupada">Desconectar</button>
        <button class="text-button" type="button" *ngIf="!balanca.conectada" (click)="conectar(true)" [disabled]="balanca.ocupada || !balanca.suportada">Escolher outra porta</button>
      </div>
      <p class="erro" *ngIf="erroConfiguracao || balanca.erro" role="alert">{{ erroConfiguracao || balanca.erro }}</p>
      <p class="aviso" *ngIf="balanca.avisoLeitura" role="status">{{ balanca.avisoLeitura.message }}</p>
      <p class="nota">Abrir a porta não confirma a comunicação. Uma resposta reconhecida confirma a comunicação, mesmo com peso instável, negativo ou em sobrecarga.</p>
    </section>
  </div>
</section>
